import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { try_add_required_permissions, try_delete_inherited_permissions } from '@/utils/utils_client_workspace_user_permissions';

interface Props {
  feature: string;
}

export const WSFeaturesNewUsersTemplateCheckbox: React.FC<Props> = ({ feature }) => {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  async function onClick() {
    if (workspace_current.permitted_features_for_new_workspace_users.includes(feature)) {
      workspace_current.permitted_features_for_new_workspace_users = try_delete_inherited_permissions(
        feature,
        workspace_current.permitted_features_for_new_workspace_users,
      );

      workspace_current.permitted_features_for_new_workspace_users = workspace_current.permitted_features_for_new_workspace_users.filter(
        item => item != feature,
      );
    } else {
      workspace_current.permitted_features_for_new_workspace_users = try_add_required_permissions(
        feature,
        workspace_current.permitted_features_for_new_workspace_users,
      );

      workspace_current.permitted_features_for_new_workspace_users = [...workspace_current.permitted_features_for_new_workspace_users, feature];
    }

    await dispatch(remote_workspace_update(workspace_current));
  }

  return <UI_PRIMITIVE__checkbox checked={workspace_current.permitted_features_for_new_workspace_users.includes(feature)} onClick={onClick} />;
};
